import { inject, injectable } from "inversify";
import { DependencyType } from "@di/DependencyType";
import { ApolloClient, NormalizedCacheObject } from "@apollo/client";
import {
  CreateCropDocument,
  CreateCropInput,
  CreateCropMutation,
  CreateCropMutationVariables,
  CropsDocument,
  CropsQuery,
  CropsQueryVariables,
} from "generated/graphql";

@injectable()
export class CropService {
  constructor(
    @inject(DependencyType.ApolloClient)
    private readonly apolloClient: ApolloClient<NormalizedCacheObject>
  ) {}

  async findAll() {
    const queryTuple = await this.apolloClient.query<
      CropsQuery,
      CropsQueryVariables
    >({
      query: CropsDocument,
    });

    if (queryTuple.errors) {
      throw new Error(queryTuple.errors[0].message);
    }

    return queryTuple.data.crops;
  }

  async create(input: CreateCropInput) {
    const mutationTuple = await this.apolloClient.mutate<
      CreateCropMutation,
      CreateCropMutationVariables
    >({
      mutation: CreateCropDocument,
      variables: {
        input,
      },
      refetchQueries: [
        {
          query: CropsDocument,
        },
      ],
      awaitRefetchQueries: true,
    });

    if (mutationTuple.errors) {
      throw new Error(mutationTuple.errors[0].message);
    }

    return mutationTuple.data?.createCrop;
  }
}
